var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 0c-224.47 0-406.45 181.98-406.45 406.44 0 4.8125 0.14453 9.707 0.35938 14.652 1.5234 42.695 9.5742 83.699 23.27 122.06 86.711 285.02 382.82 656.84 382.82 656.84s296.07-371.79 382.8-656.81c13.715-38.363 21.758-79.402 23.27-122.1 0.23828-4.9453 0.37109-9.8281 0.37109-14.652 0.011719-224.46-181.97-406.44-406.44-406.44zm0 605.51c-109.93 0-199.07-89.137-199.07-199.07 0-109.92 89.137-199.05 199.07-199.05 109.95 0 199.07 89.137 199.07 199.05 0 109.93-89.121 199.07-199.07 199.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e6a98f0c5937d624689ba8023c23e1c5.svg";
export { ForwardRef as ReactComponent };